import { render, staticRenderFns } from "./HistoryV2.vue?vue&type=template&id=33670277&scoped=true"
import script from "./HistoryV2.vue?vue&type=script&lang=js"
export * from "./HistoryV2.vue?vue&type=script&lang=js"
import style0 from "./HistoryV2.vue?vue&type=style&index=0&id=33670277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33670277",
  null
  
)

export default component.exports